import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  width: 100%;
  background-color: var(--chapter-dark);
  color: var(--paper);
  padding-block: clamp(56px, 6vw, 96px);
  padding-inline: var(--margin);
`;

export const FooterGrid = styled("div")`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: var(--gutter);

  .col-brand {
    grid-column: 1 / 4;
  }

  .col-emirates {
    grid-column: 4 / 7;
  }

  .col-nav {
    grid-column: 7 / 9;
  }

  .col-market {
    grid-column: 9 / 11;
  }

  .col-lang {
    grid-column: 11 / 13;
  }

  @media (max-width: 960px) {
    .col-brand,
    .col-emirates,
    .col-nav,
    .col-market,
    .col-lang {
      grid-column: span 6;
    }
  }

  @media (max-width: 600px) {
    .col-brand,
    .col-emirates,
    .col-nav,
    .col-market,
    .col-lang {
      grid-column: 1 / -1;
    }
  }
`;

export const FooterHeading = styled("h3")`
  font-family: 'Oswald', sans-serif;
  font-size: var(--step-lead);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--paper);
  margin: 0 0 14px 0;
`;

export const FooterPara = styled("p")`
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-body);
  color: #CBD5E1;
  margin: 0 0 10px 0;
`;

export const FooterRouteLink = styled(Link)`
  display: block;
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-body);
  font-weight: 500;
  color: #E2E8F0;
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.18s var(--ease-out);

  &:hover,
  &:focus {
    color: var(--brand-green);
  }
`;

export const FooterExternalLink = styled("a")`
  display: inline-block;
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-body);
  font-weight: 700;
  color: var(--paper);
  text-decoration: none;
  margin-bottom: 8px;

  &:hover,
  &:focus {
    color: var(--brand-green);
  }
`;

export const LanguageSwitchGroup = styled("div")`
  display: flex;
  gap: 10px;
  margin-top: 8px;

  button {
    background-color: var(--chapter-dark-surface);
    color: var(--paper);
    border: none;
    padding: 8px 14px;
    font-family: 'Barlow', sans-serif;
    font-size: var(--step-small);
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.18s var(--ease-out);
  }

  button:hover {
    background-color: var(--brand-blue);
  }
`;

export const FooterBottomBar = styled("div")`
  margin-top: 48px;
  padding: 20px 24px;
  background-color: var(--chapter-dark-surface);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  .bottom-brand {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    text-decoration: none;
    color: var(--paper);
  }

  .bottom-brand img {
    width: 40px;
    height: 40px;
  }

  .bottom-brand span {
    font-family: 'Oswald', sans-serif;
    font-size: var(--step-lead);
    font-weight: 700;
    text-transform: uppercase;
  }

  .bottom-meta {
    font-family: 'Barlow', sans-serif;
    font-size: var(--step-small);
    color: #CBD5E1;
  }
`;
